import {
  SendFullStressNotificationData,
  ActionType,
} from "models/stressCheck/fullStressSendNotification";
import { IResponse } from "models";

export const sendFullStressNotificationAction = (
  payload: SendFullStressNotificationData
) => {
  return {
    type: ActionType.SEND_FULL_NOTIFICATION,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.SEND_FULL_NOTIFICATION_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IResponse) => {
  return {
    type: ActionType.SEND_FULL_NOTIFICATION_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.RESET_SEND_FULL_NOTIFICATION,
  };
};
